import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-card-view-tab',
  templateUrl: './card-view-tab.component.html',
})
export class CardViewTabComponent {
  @Output() chosenTab: EventEmitter<any> = new EventEmitter<any>();
  @Input() title: string;
  @Input() isOpen: boolean;

  constructor() {
  }
}
